import { render, staticRenderFns } from "./ListModalityAndSubModality.vue?vue&type=template&id=8e7a6a7a"
import script from "./ListModalityAndSubModality.vue?vue&type=script&lang=js"
export * from "./ListModalityAndSubModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports